import { metaReducers } from './+state/storage.metareducer';
import { PersonCustomService } from '@medlogic/medlogic/medlogic-data-access';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { PersonEffects } from './+state/person.effects';
import { personReducer } from './+state/person.reducer';
import { StateMedlogicTenantModule } from '../medlogic-state-tenant/medlogic-state-tenant.module';

const SERVICES = [
  PersonCustomService
];

const MODULES = [
  CommonModule,
  // TODO: mover para shared
  StateMedlogicTenantModule
];

const STATE_MODULES = [
  StoreModule.forFeature('person', personReducer, { metaReducers }),
  EffectsModule.forFeature([PersonEffects]),
];

@NgModule({
  imports: [MODULES, STATE_MODULES],
  providers: [SERVICES]
})
export class StatePersonModule { }
